<template>
  <div class="visit-card__header">
    <h2 class="visit-card__title">{{ clientName }} / {{ branchName }}</h2>
    <p v-if="location" class="visit-card__subtitle">{{ location }}</p>
  </div>
</template>

<script>
export default {
  name: "VisitCardTitle",
  props: {
    clientName: String,
    branchName: String,
    // Optional (Salesmen only): shown before the address.
    region: String,
    address: String
  },
  computed: {
    /** The region and the address side by side, leaving out whichever is missing or blank. */
    location() {
      return [this.region, this.address]
        .map((part) => (part == null ? "" : String(part).trim()))
        .filter(Boolean)
        .join(" - ");
    },
  },
};
</script>
